import React, { useEffect, useRef } from 'react';
import dynamic from 'next/dynamic';
import Navbar from './navbar';
import Footer from './footer';
// import styles from '../styles/Home.module.css';
import styles from '../src/styles/Home.module.css';
import DropdownWithDescription from './dropdown';
import { useGate } from 'statsig-react';

const FaceMeshComponent = dynamic(() => import('./facemesh'), {
  loading: () => <div className="mx-auto w-full h-full skeleton"></div>,
  ssr: false,  
});

export default function Layout({ children, faceShape, eyeShape, eyeSetting, page, selectedOption }) {
  const { value: dropdown_nav } = useGate("dropdown-nav-v3");
  // const dropdown_nav = false;
  // let dropdown_nav = true;
  const feature_flag = ["face_analyzer", "face_analyzer/facial_feature",  "skintone_analyzer"].includes(page) ? "analysis" : "makeup";
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (dropdown_nav && dropdownRef.current && window.innerWidth <= 768) {
      dropdownRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [dropdown_nav]);  

  return (
    <>
      <main className="flex flex-col justify-start md:justify-between items-start min-h-screen max-w-full">
        <Navbar page={page} showDropdown={dropdown_nav} />
          {/* {page === 'makeup_recommendations' || page === 'makeup_recommendations/nose_contour' ? (
          <p className={`${feature_flag ? 'mx-auto' : 'ml-auto'}w-[300px] md:w-[480px] lg:w-[640px] px-2 text-center md:text-start`}>
            Follow the contour and concealer guides for your {page === "makeup_recommendations" ? "face" : "nose"} shape:
          </p>
        ) : (page === "makeup_recommendations/eyebrows" ? (
          <p className="ml-auto w-[300px] md:w-[480px] lg:w-[640px] px-2 text-center md:text-start">
            Use the guiding points to fill in your eyebrows:
          </p>
        ) : null)} */}
        {dropdown_nav && (
          <div ref={dropdownRef} className='w-full static'>
            <DropdownWithDescription selectedOption={selectedOption} feature_flag={feature_flag} />
          </div>
        )}        
        
        {children}
        <FaceMeshComponent page={page} faceShape={faceShape} eyeShape={ eyeShape } eyeSetting={ eyeSetting } feature_flag={feature_flag} />
        <Footer />
      </main>
    </>
  );
}